// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iM5p","right":"styles_right__18jO8"};